/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ plan: NonNullable<unknown> }} Pricing_ChooseInputs */

const en_pricing_choose = /** @type {(inputs: Pricing_ChooseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Choose ${i?.plan}`)
};

const id_pricing_choose = /** @type {(inputs: Pricing_ChooseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pilih ${i?.plan}`)
};

/**
* | output |
* | --- |
* | "Choose {plan}" |
*
* @param {Pricing_ChooseInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const pricing_choose = /** @type {((inputs: Pricing_ChooseInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_ChooseInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_pricing_choose(inputs)
	return en_pricing_choose(inputs)
});